import React from "react";

/**  Lazy loading components for improved performance
*   React.lazy is used to dynamically import components when they are needed
*/

export const AdminLogin = React.lazy(() => import("./Login/index.page"));
export const AdminForgotPassword = React.lazy(() =>
  import("./ForgotPassword/index.page")
);
export const AdminOtpVerification = React.lazy(() =>
  import("./OtpVerification/index.page")
);
export const AdminResetPassword = React.lazy(() =>
  import("./ResetPassword/index.page")
);
export const AdminProfile = React.lazy(() =>
  import("./AdminAccount/AdminProfile/index.page")
);
export const AdminChangePassword = React.lazy(() =>
  import("./AdminAccount/AdminChangePassword/index.page")
);
export const AdminNotifications = React.lazy(() =>
  import("./AdminAccount/AdminNotifications/index.page")
);
export const AdminDashboard = React.lazy(() =>
  import("./Dashboard/index.page")
);
export const NotificationManagement = React.lazy(() =>
  import("./NotificationManagement/index.page")
);
export const TransactionManagement = React.lazy(() =>
  import("./TransactionManagement/index.page")
);
export const BookRequest = React.lazy(() =>
  import("./BookRequest/index.page")
);
// Exporting components related to user management,book management,category management,subscription management  and CMS management
export * from "./UserManagement";
export * from "./ManageCms";
export * from "./BookManagement";
export * from "./BookCategoryManagement";
export * from "./ManageSubscription";
